import { ListSizeOverTime } from "@oldDashboard/legacyModels/listSizeOverTime.model";
import { ListSizeOverTimeSerializer } from "@oldDashboard/legacyModels/serializers/listSizeOverTimeSerializer";
import { legacyReportingGet } from "@oldDashboard/legacyUtils";
export class CommandGetListSizeOverTime {

    async run(launchSelected: String, timePeriodSelected: String) {  
        const path = `get-chart-data/client:list-size-over-time/?launch_id=${launchSelected}&time_period=${timePeriodSelected}`
        try {
            const response = await legacyReportingGet(path);
            if(response.success)
                return this.deserialize(response.chart_data.series_data);
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }

    }

    deserialize(data: any) : ListSizeOverTime [] {
        const serializer = new ListSizeOverTimeSerializer();
        return serializer.deserializeList(data);
    }
}

